'use client'
import { apiResponseHandler } from '@/shared/api/react-query'
import { useMutation } from '@tanstack/react-query'
import services from '../services'
import { toast } from '@/shared/ui/use-toast'
import { paths } from '@/shared/routing'
import { useRouter } from '@/shared/config/i18n'
import { ChangePasswordDto } from '../../lib'

export function useChangePassword() {
  const router = useRouter()
  const mutations = useMutation({
    mutationFn: async (params: ChangePasswordDto) => apiResponseHandler(await services.changePassword(params)),
    onError: (error) => {
      toast({
        variant: 'destructive',
        title: 'Ошибка!',
        description: error?.message || 'Вы не авторизовались!',
      })
    },
    onSuccess: async (res) => {
      if (res) {
        toast({
          variant: 'default',
          title: 'Пароль успешно обновлен.',
          description: res,
        })
        router.push(paths.login)
        router.refresh()
      }
    },
  })

  return mutations
}
